import { buildModelManager } from "../builder.js";
const DefaultLibraryFlowSelection = {
  __typename: true,
  id: true,
  automationType: true,
  category: true,
  createdAt: true,
  description: true,
  flowImageUrl: true,
  fullDescription: true,
  isActive: true,
  isAutomation: true,
  isPromoted: true,
  originalScenarioId: true,
  position: true,
  requirements: true,
  tags: true,
  thumbnailUrl: true,
  title: true,
  updatedAt: true
};
const modelApiIdentifier = "libraryFlow";
const pluralModelApiIdentifier = "libraryFlows";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultLibraryFlowSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultLibraryFlowSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultLibraryFlowSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultLibraryFlowSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultLibraryFlowSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultLibraryFlowSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultLibraryFlowSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createLibraryFlow",
    operationReturnType: "CreateLibraryFlow",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      libraryFlow: { required: false, type: "CreateLibraryFlowInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultLibraryFlowSelection
  },
  {
    type: "action",
    operationName: "bulkCreateLibraryFlows",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateLibraryFlowsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultLibraryFlowSelection
  },
  {
    type: "action",
    operationName: "updateLibraryFlow",
    operationReturnType: "UpdateLibraryFlow",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      libraryFlow: { required: false, type: "UpdateLibraryFlowInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultLibraryFlowSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateLibraryFlows",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateLibraryFlowsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultLibraryFlowSelection
  },
  {
    type: "action",
    operationName: "deleteLibraryFlow",
    operationReturnType: "DeleteLibraryFlow",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteLibraryFlows",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertLibraryFlow",
    operationReturnType: "UpsertLibraryFlow",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      libraryFlow: { required: false, type: "UpsertLibraryFlowInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateLibraryFlowResult": { hasReturnType: false },
      "... on UpdateLibraryFlowResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultLibraryFlowSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertLibraryFlows",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertLibraryFlowsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultLibraryFlowSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "libraryFlowGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const LibraryFlowManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultLibraryFlowSelection,
  operations
);
export {
  DefaultLibraryFlowSelection,
  LibraryFlowManager
};
//# sourceMappingURL=LibraryFlow.js.map
